import React from 'react';
import { Link, Text, View, StyleSheet, Image } from '@react-pdf/renderer';
import logo from "../../../src/img/logos.png"
import moment, { localeData } from "moment";

// import moment from 'moment';
const styles = StyleSheet.create({
  headerBG: {
    backgroundColor: "white",
    width: "100%",
    height: "110px",
    border: "none",
  },
  container: {
    flexDirection: 'row',
    alignItems: 'stretch',
  },
  headerTop: {  
    width: "980",
    padding: "20px 30px",
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent:"space-between",
  },  
  detailColumn: {
    flexDirection: 'column',
    textTransform: 'uppercase',
    justifyContent: "flex-start",
  },
  linkColumn: {
     marginBottom:"10px",
    fontSize: 14
  },
  caseMangement: {
    fontSize: 20,
    fontFamily: 'Lato Bold',
    margin: "3px 0px 30px 0", width: "100%",
    color: "#000000", textAlign: "center", textTransform: 'capitalize',
  },
  bgColorured: {
    display: "flex",
    flexDirection: "row",
    width: '100%',
    backgroundColor: '#f3f3f3',
  },
  background: {
    display: "flex",
    flexDirection: "row",
    width: '100%',
    backgroundColor: '#ffffff',
  },
  leftField: {
    fontFamily: 'Lato',
    fontSize: 13, textTransform: 'capitalize',
    color: "#636363", padding: '10px',
    margin: "2px 0", width: "50%", textAlign: "left",
  },
  rightField: {
    fontFamily: 'Lato',
    fontSize: 13, padding: '10px',
    color: "#636363", textTransform: 'capitalize', fontWeight: '800',
    margin: "2px 0", width: "50%", textAlign: "left",
  },
  logo: {
    textAlign: "left",
    width: "100px"
  },
  image: {
    textAlign: "right",
    width: "70px",
    height:"36px"
  },
  imagenew: {
    textAlign: "right",
    width: "70px",
    height:"50x"
  }
});

export default function HeaderPDF(props) {
  let data = props && props.data && props.data.data?props.data.data:{}
  return <View style={styles.headerBG} fixed>
    <View style={styles.container}>
        <View style={styles.headerTop}>
            <View style={styles.detailColumn}>
                <View style={styles.logo}>
                  <Image src={logo}/>
                </View>
                <Text style={styles.caseMangement}>Case Management Log</Text>
                {Object.keys(data).length>0?  <>
               <View style={styles.bgColorured}>
                  <Text style={styles.leftField} >Mentee Name :</Text>
                  <Text style={styles.rightField} >{data.mentee_name}</Text>
                </View>
                <View style={styles.background}>
                  <Text style={styles.leftField} >Mentor Name :</Text>
                  <Text style={styles.rightField} >{data.mentor_name}</Text>
                </View>
                <View style={styles.bgColorured}>
                  <Text style={styles.leftField} >Contact Date :</Text>
                  <Text style={styles.rightField} >{moment
                                      .unix(data.created_at.seconds)
                                      .format("MM/DD/YYYY")}</Text>
                </View>
                <View style={styles.background}>
                  <Text style={styles.leftField} >Meeting Duration :</Text>
                  <Text style={styles.rightField} >{data.meeting_duration}</Text>
                </View>
                <View style={styles.bgColorured}>
                  <Text style={styles.leftField} >Gender :</Text>
                  <Text style={styles.rightField} >{data.gender}</Text>
                </View>
                <View style={styles.background}>
                  <Text style={styles.leftField} >Ethnicity :</Text>
                  <Text style={styles.rightField} >{data.ethnicity}</Text>
                </View>
                <View style={styles.bgColorured}>
                  <Text style={styles.leftField} >Referral Type :</Text>
                  <Text style={styles.rightField} >{data.referral_type.join(',')}</Text>
                </View>
                <View style={styles.background}>
                  <Text style={styles.leftField} >Employment Type :</Text>
                  <Text style={styles.rightField} >{data.employment_type}</Text>
                </View>
                <View style={styles.bgColorured}>
                  <Text style={styles.leftField} >Mentee Goal :</Text>
                  <Text style={styles.rightField} >{data.mentee_goal}</Text>
                </View>
                <View style={styles.background}>
                  <Text style={styles.leftField} >Risk Status :</Text>
                  <Text style={styles.rightField} >{data.risk_status}</Text>
                </View>
                <View style={styles.bgColorured}>
                  <Text style={styles.leftField} >Housing Status :</Text>
                  <Text style={styles.rightField} >{data.housing_status}</Text>
                </View>
                <View style={styles.background}>
                  <Text style={styles.leftField} >Session Activity :</Text>
                  <Text style={styles.rightField} >{data.session_activity.join(',')}</Text>
                </View>
                <View style={styles.bgColorured}>
                  <Text style={styles.leftField} >Progress :</Text>
                  <Text style={styles.rightField} >{data.progress}</Text>
                </View>
                <View style={styles.background}>
                  <Text style={styles.leftField} >Steps :</Text>
                  <Text style={styles.rightField} >{data.steps}</Text>
                </View>
           
                <View style={styles.bgColorured}>
                  <Text style={styles.leftField} >Success :</Text>
                  <Text style={styles.rightField} >{data.success}</Text>
                </View>
                <View style={styles.background}>
                  <Text style={styles.leftField} >Comments :</Text>
                  <Text style={styles.rightField} >{data.comments}</Text>
                </View>
           
                <View style={styles.bgColorured}>
                  <Text style={styles.leftField} >Concern :</Text>
                  <Text style={styles.rightField} >{ data.concern}</Text>
                </View>
                </>:null}
            </View>
           
        </View>
    </View>
   </View>


}